import { MDBIcon } from 'mdbreact'
import React from 'react'

import styles from './EventSearch.module.css'

const EventSearch = ({ inputProps = {}, containerStyle = {}, buttonProps = {} }) => {
    return (
        <div className={`${styles['search-container']}`} style={{ ...containerStyle }}>
            <button aria-label="Search" className={`${styles['search-button']}`} {...buttonProps}><MDBIcon fas icon="search" /></button>
            <input placeholder={inputProps.placeholder || window.I18N('search_event')} type="search" {...inputProps} aria-label="Search Input" />
        </div>
    )
}

export default EventSearch
